module.exports = __webpack_public_path__ + "static/media/smartkiss.be551314.webp";